import { ReactNode, useId } from "react"
import { Input, InputProps } from "components/ui/Input"
import { Label } from "components/ui/Label"

export interface TextFieldProps extends Omit<InputProps, "hasError"> {
  label: ReactNode
  /** Error message; when set, the input renders in its invalid state. */
  error?: string
  /** Helper text shown below the input when there is no error. */
  hint?: ReactNode
  /** Optional node rendered on the right of the label row (e.g. a link). */
  labelAction?: ReactNode
}

/** A labelled text input with optional error and hint text. */
export const TextField = ({
  label,
  error,
  hint,
  labelAction,
  id,
  ...inputProps
}: TextFieldProps) => {
  const generatedId = useId()
  const inputId = id ?? generatedId

  return (
    <div>
      <div className="flex items-center justify-between">
        <Label htmlFor={inputId}>{label}</Label>
        {labelAction}
      </div>
      <div className="mt-2">
        <Input id={inputId} hasError={!!error} {...inputProps} />
      </div>
      {error ? (
        <p className="mt-2 text-sm text-red-600">{error}</p>
      ) : hint ? (
        <p className="mt-2 text-sm text-gray-500">{hint}</p>
      ) : null}
    </div>
  )
}
